/*
 * Example of using grid editing callbacks \ functions
 */

rs.module("development/codedemosdates", [],

    function () {

        function initialize(jsSelectors) {

            $.js(jsSelectors.validate).on("click", function () {

                var datebox = $.js(jsSelectors.datebox)[0];

                console.log({
                    valid: datebox.validity.valid,
                    valueMissing: datebox.validity.valueMissing,
                    badInput: datebox.validity.badInput,
                });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);